import React from 'react';
import PropTypes from 'prop-types';

const InboxRemainderIcon = ({ className = '', size = 20, color = '#05805c', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.80909 16.3636H2.72727C2.00395 16.3636 1.31026 16.0763 0.7988 15.5648C0.287337 15.0534 0 14.3597 0 13.6364V2.72727C0 2.00395 0.287337 1.31026 0.7988 0.7988C1.31026 0.287337 2.00395 0 2.72727 0H13.6364C14.3597 0 15.0534 0.287337 15.5648 0.7988C16.0763 1.31026 16.3636 2.00395 16.3636 2.72727V9.7H14.5455V2.72727C14.5455 2.48617 14.4497 2.25494 14.2792 2.08445C14.1087 1.91396 13.8775 1.81818 13.6364 1.81818H2.72727C2.48617 1.81818 2.25494 1.91396 2.08445 2.08445C1.91396 2.25494 1.81818 2.48617 1.81818 2.72727V13.6364C1.81818 13.8775 1.91396 14.1087 2.08445 14.2792C2.25494 14.4497 2.48617 14.5455 2.72727 14.5455H9.80909V16.3636Z"
        fill={color}
      />
      <path
        d="M4.54581 5.45392C5.04789 5.45392 5.4549 5.04691 5.4549 4.54483C5.4549 4.04276 5.04789 3.63574 4.54581 3.63574C4.04373 3.63574 3.63672 4.04276 3.63672 4.54483C3.63672 5.04691 4.04373 5.45392 4.54581 5.45392Z"
        fill={color}
      />
      <path
        d="M11.8189 3.63574H8.18253C7.68045 3.63574 7.27344 4.04276 7.27344 4.54483C7.27344 5.04691 7.68045 5.45392 8.18253 5.45392H11.8189C12.321 5.45392 12.728 5.04691 12.728 4.54483C12.728 4.04276 12.321 3.63574 11.8189 3.63574Z"
        fill={color}
      />
      <path
        d="M14.5444 19.9999C13.4656 19.9999 12.411 19.68 11.514 19.0807C10.617 18.4813 9.91789 17.6294 9.50505 16.6327C9.09221 15.636 8.98419 14.5393 9.19465 13.4812C9.40512 12.4232 9.92461 11.4513 10.6874 10.6884C11.4503 9.92559 12.4222 9.4061 13.4803 9.19563C14.5383 8.98517 15.6351 9.09318 16.6318 9.50603C17.6284 9.91887 18.4803 10.618 19.0797 11.515C19.679 12.412 19.9989 13.4666 19.9989 14.5454C19.9989 15.992 19.4243 17.3794 18.4013 18.4023C17.3784 19.4252 15.991 19.9999 14.5444 19.9999ZM14.5444 10.909C13.8252 10.909 13.1221 11.1223 12.5241 11.5218C11.9261 11.9214 11.4601 12.4893 11.1848 13.1538C10.9096 13.8183 10.8376 14.5494 10.9779 15.2548C11.1182 15.9602 11.4645 16.6081 11.9731 17.1167C12.4816 17.6252 13.1296 17.9715 13.835 18.1119C14.5404 18.2522 15.2715 18.1802 15.936 17.9049C16.6004 17.6297 17.1683 17.1636 17.5679 16.5656C17.9675 15.9676 18.1808 15.2646 18.1808 14.5454C18.1808 13.5809 17.7976 12.656 17.1157 11.9741C16.4337 11.2921 15.5088 10.909 14.5444 10.909Z"
        fill={color}
      />
      <path
        d="M15.4007 12.3518L14.17 13.6902C13.8302 14.0598 13.8543 14.6349 14.2239 14.9747C14.5934 15.3146 15.1685 15.2905 15.5084 14.9209L16.7391 13.5825C17.0789 13.2129 17.0548 12.6378 16.6852 12.298C16.3157 11.9582 15.7406 11.9823 15.4007 12.3518Z"
        fill={color}
      />
    </svg>
  );
};

InboxRemainderIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default InboxRemainderIcon;
